import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface UIState {
  viewMode: 'list' | 'calendar'
  selectedPlans: string[]
  showStatisticsPanel: boolean
  currentMonth: Date
  sidebarCollapsed: boolean
  loading: {
    global: boolean
    planList: boolean
    planDetail: boolean
    assignment: boolean
  }
}

const initialState: UIState = {
  viewMode: 'list',
  selectedPlans: [],
  showStatisticsPanel: false,
  currentMonth: new Date(),
  sidebarCollapsed: false,
  loading: {
    global: false,
    planList: false,
    planDetail: false,
    assignment: false,
  },
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setViewMode: (state, action: PayloadAction<'list' | 'calendar'>) => {
      state.viewMode = action.payload
    },
    setSelectedPlans: (state, action: PayloadAction<string[]>) => {
      state.selectedPlans = action.payload
    },
    addSelectedPlan: (state, action: PayloadAction<string>) => {
      if (!state.selectedPlans.includes(action.payload)) {
        state.selectedPlans.push(action.payload)
      }
    },
    removeSelectedPlan: (state, action: PayloadAction<string>) => {
      state.selectedPlans = state.selectedPlans.filter(id => id !== action.payload)
    },
    clearSelectedPlans: (state) => {
      state.selectedPlans = []
    },
    toggleStatisticsPanel: (state) => {
      state.showStatisticsPanel = !state.showStatisticsPanel
    },
    setShowStatisticsPanel: (state, action: PayloadAction<boolean>) => {
      state.showStatisticsPanel = action.payload
    },
    setCurrentMonth: (state, action: PayloadAction<Date>) => {
      state.currentMonth = action.payload
    },
    toggleSidebar: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed
    },
    setSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      state.sidebarCollapsed = action.payload
    },
    setGlobalLoading: (state, action: PayloadAction<boolean>) => {
      state.loading.global = action.payload
    },
    setPlanListLoading: (state, action: PayloadAction<boolean>) => {
      state.loading.planList = action.payload
    },
    setPlanDetailLoading: (state, action: PayloadAction<boolean>) => {
      state.loading.planDetail = action.payload
    },
    setAssignmentLoading: (state, action: PayloadAction<boolean>) => {
      state.loading.assignment = action.payload
    },
    setLoading: (state, action: PayloadAction<Partial<UIState['loading']>>) => {
      state.loading = { ...state.loading, ...action.payload }
    },
  },
})

export const {
  setViewMode,
  setSelectedPlans,
  addSelectedPlan,
  removeSelectedPlan,
  clearSelectedPlans,
  toggleStatisticsPanel,
  setShowStatisticsPanel,
  setCurrentMonth,
  toggleSidebar,
  setSidebarCollapsed,
  setGlobalLoading,
  setPlanListLoading,
  setPlanDetailLoading,
  setAssignmentLoading,
  setLoading,
} = uiSlice.actions

export default uiSlice.reducer